module.exports = __webpack_public_path__ + "static/media/moz.bf7aa8d5.svg";